<template>
  <v-modal
    :name="name"
    title="Vibbrante selecionado"
    :show="show"
    @onHide="onHide"
    :size="2"
  >
    <v-inner>
      <v-text class="p-3"
        >Profissional foi adicionado aos Selecionados para requisão.</v-text
      >
      <v-divider line />
      <v-row class="size-2" style="text-right">
        <v-col xs="6" sm="8">
          <v-button class="block primary" @click="fireGoToSelecteds()"
            >Acessar os selecionados</v-button
          >
        </v-col>
        <v-col xs="6" sm="4">
          <v-button class="block gray" @click="hide()">Fechar</v-button>
        </v-col>
      </v-row>
    </v-inner>
  </v-modal>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'client',
    },
    data: {},
  },
  methods: {
    fireGoToSelecteds() {
      this.$emit('onGoSelectedVibbrantes');
      this.hide();
    },
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/confirm-selected-vibbrante.vue